import React from "react";
import { AlternativePaymentMethod } from "../../constants/alternativePaymentMethod";
import { FlywireMethod } from "./components/FlywireMethod";
import { cashInCashOutTypes } from "../../constants/cashInCashOutTypes";
import ResponsiveDialog from "../../../../../../shared/components/ResponsiveDialog";

export const AlternativePaymentMethodFactory = ({
  alternativePaymentMethod,
  onSubmitForm,
  showAlternativePaymentDialog,
  setShowAlternativePaymentDialog,
}) => {
  const getAlternativePaymentMethodModule = () => {
    switch (alternativePaymentMethod) {
      case AlternativePaymentMethod.FLYWIRE:
        return (
          <FlywireMethod
            onSubmitForm={() =>
              onSubmitForm({ type: cashInCashOutTypes.FLYWIRE })
            }
          />
        );
      default:
        return undefined;
    }
  };

  const alternativePaymentMethodModule = getAlternativePaymentMethodModule();

  if (!alternativePaymentMethodModule) return <></>;

  return (
    <ResponsiveDialog
      PaperProps={{
        "aria-label": "Alternative payment method dialog",
      }}
      className={showAlternativePaymentDialog ? "fade-in" : "fade-out"}
      displayCondition={true}
      fullScreenCondition={true}
      open={true}
      onClose={() => {
        setShowAlternativePaymentDialog(false);
      }}
    >
      {alternativePaymentMethodModule}
    </ResponsiveDialog>
  );
};
